import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import { useTranslation } from 'react-i18next'; // Añade esta línea
import UserProfileDropdown from './UserProfileDropdown';
import './styles/Headercustom.css';

function Header({ user, setUser }) {
  const { t } = useTranslation(); // Añade esta línea
 // const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="menu-container" ref={menuRef}>
          <button type="button" className="menu-toggle" onClick={toggleMenu}
            aria-label={t('navigationMenu')} aria-expanded={isMenuOpen} aria-controls="main-navigation"
            onKeyDown={event => { if (event.key === 'Escape') closeMenu(); }}>
            <FiMenu size={22} aria-hidden="true" />
          </button>
          <nav id="main-navigation" className={`menu-dropdown ${isMenuOpen ? 'open' : ''}`}
            onKeyDown={event => { if (event.key === 'Escape') { closeMenu(); menuRef.current.querySelector('button').focus(); } }}>
            <ul>
              <li><Link to="/" onClick={closeMenu}>{t('home')}</Link></li>
              {user && <li><Link to="/games" onClick={closeMenu}>{t('games')}</Link></li>}
              {user && <li><Link to="/create-game" onClick={closeMenu}>{t('createGame')}</Link></li>}
              {user && <li><Link to="/statistics" onClick={closeMenu}>{t('statistics')}</Link></li>}
              {/* Add more menu items here as needed */}
              <li><Link to="/help" onClick={closeMenu}>{t('help')}</Link></li>
            </ul>
          </nav>
        </div>
        <Link to="/" className="logo-link" aria-label="Tarjeta Golf">
          <img src="/tarjeta-golf-mark.svg" alt="" className="logo-image" width="40" height="40" />
          <span className="brand-name">Tarjeta Golf</span>
        </Link>
        {user && <UserProfileDropdown user={user} setUser={setUser} />}
      </div>
    </header>
  );
}

export default Header;
